import React, { useState } from 'react'
import { trackAddToCart } from '@helpers/trackCartActions'
import { handleAddToCart } from '../../utils/helpers/global'
import { Product, ProductVariant } from '../../utils/interfaces/product'
import KlaviyoBISForm from '../../utils/components/atoms/KlaviyoBISForm'
import { doConfetti } from '../../utils/confetti'

interface AddToCartButtonProps {
  product: Product
  currentVariant: ProductVariant
  quantity?: number
}

const AddToCartButton: React.FC<AddToCartButtonProps> = ({ product, currentVariant, quantity }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const openModal = () => setIsModalOpen(true)
  const closeModal = () => setIsModalOpen(false)
  const handleNotifyClick = () => openModal()

  const comingSoonProduct = currentVariant.metafields?.badges.find((badge) => badge.name.includes('Coming'))
  const limitedProduct = currentVariant?.metafields?.badges.find((badge) => badge.name.includes('Limited'))
  const earlyAccessProduct = currentVariant?.metafields?.badges.find((badge) => badge.name.includes('Early'))
  const earlyAccessRule = earlyAccessProduct && !currentVariant.customerLoggedIn

  const exclusiveProduct = currentVariant?.metafields?.badges.find((badge) => badge.name.includes('Exclusive'))
  const exclusiveRule = exclusiveProduct && !currentVariant.customerLoggedIn
  if (exclusiveRule) {
    return (
      <a href="/account" aria-label="Link to account page to log in or sign up to purchase this product">
        <button
          type="button"
          className="button button--secondary"
          aria-label="Sign Up To Purchase this Pitcoin Exlusive Product"
        >
          <div className="rectangle-1"></div>
          <div className="button-text">{window.DEPT.Strings.product.exclusiveProductCTA}</div>
        </button>
      </a>
    )
  }

  const handleAddToCartClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    handleAddToCart(currentVariant.id, quantity, currentVariant.metafields?.relatedVariants)
    trackAddToCart(product, currentVariant, quantity)
    doConfetti(e.currentTarget)
  }

  return (
    <>
      <KlaviyoBISForm
        productTitle={product.title}
        variantID={currentVariant.legacyResourceId}
        comingSoon={comingSoonProduct || earlyAccessRule ? true : false}
        limitedEdition={limitedProduct ? true : false}
        klaviyoAPIKey={product.klaviyoApiKey}
        limitedEditionList={product.limitedEditionList}
        emailList={product.emailList}
        variantTitle={currentVariant.title}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
      />
      <button
        type="submit"
        id={currentVariant?.availableForSale ? 'add_to_cart' : 'klaviyo_bis'}
        data-variant-id={currentVariant.id}
        aria-label={`${comingSoonProduct || earlyAccessRule ? 'Open Modal to sign up for notifications for when this product is available' : currentVariant?.availableForSale ? 'Add To Cart' : 'Open Modal To Sign Up for Restock Notifications'}`}
        className={`button w-full md:w-auto ${currentVariant?.availableForSale ? 'button--primary' : 'button--secondary'}`}
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault()
          if (comingSoonProduct || earlyAccessRule) {
            handleNotifyClick()
          } else if (currentVariant?.availableForSale) {
            handleAddToCartClick(e)
          } else {
            handleNotifyClick()
          }
        }}
        aria-expanded={isModalOpen}
        aria-haspopup="dialog"
      >
        <div className="rectangle-1"></div>
        <div className="button-text">
          {currentVariant
            ? comingSoonProduct || earlyAccessRule
              ? window.DEPT.Strings.product.notifyMe
              : currentVariant?.availableForSale
                ? window.DEPT.Strings.product.addToCart
                : limitedProduct
                  ? window.DEPT.Strings.product.limitedEditionCTA
                  : window.DEPT.Strings.product.notifyMe
            : window.DEPT.Strings.product.unavailable}
        </div>
      </button>
    </>
  )
}
export default AddToCartButton
